import { createFileRoute } from '@tanstack/react-router';

import { SolicitudDetail } from '@/features/compliance/components/solicitud-detail';
import { ComplianceSectionTabs } from '@/features/compliance/components/compliance-section-tabs';

export const Route = createFileRoute('/_app/compliance/arco/$id')({
  component: ComplianceArcoDetailRoute,
});

function ComplianceArcoDetailRoute() {
  const { id } = Route.useParams();
  return (
    <div className="flex flex-col gap-6">
      <ComplianceSectionTabs />
      <SolicitudDetail solicitudId={id} />
    </div>
  );
}
